// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DID_YOU_KNOW = "Vedela si, \u017ee...";
export const FORUMS_ACCUSATIVE = "f\u00f3ra";
export const HINT_FOR_FORUMS = "%(FORUMS)s m\u00f4\u017eu \u010d\u00edta\u0165 v\u0161etci (aj Google). Prispieva\u0165 do nich m\u00f4\u017eu len prihl\u00e1sen\u00e9 pou\u017e\u00edvate\u013eky.";
export const NEWEST_DISCUSSIONS = "Najnov\u0161ie diskusie";
export const SHORTENED_ORDER_BY = "Zora\u010f";
export const SHORTENED_SEARCH_IN_FORUM = "H\u013eadaj vo f\u00f3rach...";
export const WHERE_ARE_DISCUSSIONS = "Kde sa pr\u00e1ve diskutuje";
